import {CheckCircleOutlined} from '@ant-design/icons';
import {Button, Form, Input} from 'antd';
import {useState} from 'react';

import texture from '../../assets/AboutUs/download.jpg';

const {TextArea} = Input;

const ContactUsForm = () => {

  const [form] = Form.useForm();
  const [isSubmitted, setIsSubmitted] = useState(false);

  const onFinish = values => {

    const {username, email, contact_no, message} = values;

    let whatsappMessage = `Hello, I submitted an enquiry:

Name: ${username}
Contact: ${contact_no}
Message: ${message}`;

    if (email) {
      whatsappMessage += `\nEmail: ${email}`;
    }

    const phoneNumber = '9371100954';

    const url =
      `https://wa.me/${phoneNumber}?text=${encodeURIComponent(
        whatsappMessage,
      )}`;

    window.open(url, '_blank');

    setIsSubmitted(true);

    form.resetFields();
  };

  return (

    <div className={'w-full'}>

      {/* HERO */}
      <div
        className={'text-center py-20 px-6 text-white'}
        style={{
          backgroundColor: '#7a2e22',
          backgroundImage: `url(${texture})`,
          backgroundBlendMode: 'multiply',
        }}
      >

        <h1
          data-aos={'fade-up'}
          className={'font-heading text-4xl lg:text-5xl'}
        >
          Contact Us
        </h1>

        <div className={'luxury-divider mx-auto'} />

        <p
          data-aos={'fade-up'}
          data-aos-delay={'200'}
          className={'mt-6 max-w-xl mx-auto font-body opacity-90'}
        >
          Have a question about our jewellery collections,
          bulk orders or custom designs?

          We would love to hear from you.
        </p>

      </div>

      {/* FORM SECTION */}
      <div className={'max-w-6xl mx-auto px-4 sm:px-6 py-12 sm:py-16 overflow-hidden'}>

        <div className={'grid  lg:grid-cols-2 gap-10 items-center'}>

          {/* LEFT INFO */}
          <div data-aos={'fade-right'}>

            <h2 className={'font-heading text-3xl mb-3'}>
              Get in Touch
            </h2>

            <div className={'luxury-divider'} />

            <p className={'mt-6 font-body text-gray-600 leading-relaxed'}>
              Whether you re looking for elegant jewellery,
              partnership opportunities, or custom designs,
              our team is here to assist you.
            </p>

            <div className={'mt-8 space-y-3 text-gray-600 font-body'}>

              <p>
                📍 Ratnaparkhi Jewellers
              </p>

              <p>
                📞 +91 9371100954
              </p>

              <p>
                💎 Premium  Jewellery
              </p>

            </div>

          </div>

          {/* FORM */}
          <div
            data-aos={'fade-left'}
            className={'bg-white shadow-xl rounded-2xl border p-5 sm:p-6 lg:p-8 w-full max-w-md mx-auto lg:max-w-none'}>

            {isSubmitted ? (

              <div className={'flex flex-col items-center justify-center text-center'}>

                <CheckCircleOutlined
                  className={'text-3xl text-green-600 mb-3'}
                />

                <h3 className={'font-heading text-xl'}>
                  Thank you for contacting us
                </h3>

                <p className={'font-body text-gray-500 mt-2'}>
                  We will respond within 24 hours.
                </p>

              </div>

            ) : (

              <Form
                form={form}
                layout={'vertical'}
                onFinish={onFinish}
                className={'space-y-6'}
              >

                <Form.Item
                  label={'Full Name'}
                  name={'username'}
                  rules={[
                    {required: true, message: 'Please enter your name'},
                  ]}
                >

                  <Input
                    placeholder={'Enter your name'}
                    className={'h-10 rounded-lg'}
                  />

                </Form.Item>

                <Form.Item
                  label={'Email (optional)'}
                  name={'email'}
                  rules={[
                    {type: 'email', message: 'Invalid email'},
                  ]}
                >

                  <Input
                    placeholder={'Enter email'}
                    className={'h-10 rounded-lg'}
                  />

                </Form.Item>

                <Form.Item
                  label={'Contact Number'}
                  name={'contact_no'}
                  rules={[
                    {required: true, message: 'Enter contact number'},
                    {
                      pattern: /^\d{10}$/,
                      message: 'Enter valid 10 digit number',
                    },
                  ]}
                >

                  <Input
                    placeholder={'10 digit mobile number'}
                    className={'h-10 rounded-lg'}
                  />

                </Form.Item>

                <Form.Item
                  label={'Message'}
                  name={'message'}
                  rules={[
                    {required: true, message: 'Enter message'},
                  ]}
                >

                  <TextArea
                    placeholder={'Tell us your requirement...'}
                    rows={4}
                    className={'rounded-lg'}
                  />

                </Form.Item>

                <Form.Item>

                  <Button
                    htmlType={'submit'}
                    className={'w-full h-11 bg-primary-900 text-white rounded-lg transition-all duration-500 hover:scale-[1.02]'}
                  >

                    Submit Enquiry

                  </Button>

                </Form.Item>

              </Form>

            )}

          </div>

        </div>

      </div>

      {/* FOOTER TEXT */}
      <div className={'text-center pb-12 text-gray-400 text-sm font-body'}>
        Elegant Designs • Trusted Craftsmanship • Timeless Beauty
      </div>

    </div>

  );

};

export default ContactUsForm;
